<template>
  <div class="container">
    <!-- 发视频 -->
    <div class="video-box">
      <div class="hasVideo" v-if="uploadviedoSrcFull">
        <video
          id="myVideo"
          webkit-playsinline="true"
          x5-video-player-type="h5-page"
          x5-video-player-fullscreen="true"
          playsinline
          controls="true"
          show-center-play-btn="true"
          :src="uploadviedoSrcFull"
        ></video>
        <div class="delete" @click="deleteVideoClick">
          <img src="../../../static/images/icon/delete.png" />
        </div>
      </div>
      <van-uploader
        v-else
        accept="video/*"
        :before-read="beforeRead"
        :after-read="afterRead"
      ></van-uploader>
    </div>
    <div class="textarea">
      <div v-if="topicShow || productShow">{{ textVal }}</div>
      <textarea
        v-else
        rows="6"
        v-model="textVal"
        placeholder="填写标题会有更多赞哦..."
        maxlength="100"
      ></textarea>
    </div>

    <div class="handle-box">
      <div class="hb_item" @click.stop="topicChange">
        <div class="iconfont icon-huati1"></div>
        <div>
          <div v-if="topic.length == 0">关联话题</div>
          <div class="hb_scroll special" v-else>
            <div class="hbs_view" v-for="(item, index) in topic" :key="index">
              <div class="hbst_item">
                <div class="overFlowOne">{{ item.TopicName }}</div>
                <div class="s_delete" @click.stop="topicDelete">
                  <van-icon name="cross" color="#aaa" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="iconfont icon-right"></div>
      </div>

      <div class="hb_item" @click.stop="getUserLocation">
        <div class="iconfont icon-dingwei"></div>
        <div>
          <div v-if="!location">获取定位</div>
          <div class="hb_scroll" v-else>
            <div class="hbs_view">{{ location }}</div>
          </div>
        </div>
        <div class="iconfont icon-right"></div>
      </div>

      <div class="hb_item" @click.stop="productChange" v-if="isStore == 1">
        <div class="iconfont icon-product"></div>
        <div>
          <div v-if="!product">关联产品</div>
          <div class="hb_scroll" v-else>
            <div class="hbs_view">
              <div class="hbsp_item">
                <div class="overFlowOne">{{ product.GoodsName }}</div>
                <img :src="product.Thumbnail" />
              </div>
            </div>
          </div>
        </div>
        <div class="iconfont icon-right"></div>
      </div>
    </div>
    <div
      class="submitBtn"
      @click.stop="submitClick"
      :style="disabled ? 'pointer-events: none;background: #dddddd;' : ''"
    >
      发 布
    </div>

    <!-- 话题弹窗 -->
    <van-overlay v-show="topicShow" z-index="11" @click.stop="onClickHide">
      <div class="wrapper">
        <div class="wrapper-choice-box" @click.stop="controlTap">
          <div class="wcb_top">
            <div>关联话题</div>
            <div @click.stop="topicComplete">完成</div>
          </div>
          <div class="wcb_search">
            <van-search
              shape="round"
              background="transparent"
              placeholder="话题关键词"
              v-model="topicValue"
              maxlength="100"
              @search="topicSearchConfirm"
            />
            <div class="searchBtn" @click.stop="topicSearchConfirm">搜索</div>
          </div>
          <div class="wcb_already">
            还可以关联 {{ 3 - topic.length }} 个话题
          </div>
          <div class="wcb_scroll">
            <div class="wcbs_wrap">
              <div v-for="(item, index) in topicList" :key="index">
                <div
                  class="wcbst_item overFlowOne"
                  :class="item.selected ? 'active' : ''"
                  @click.stop="topicChoice(index)"
                >
                  {{ item.TopicName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 产品弹窗 -->
    <van-overlay v-show="productShow" z-index="11" @click.stop="onClickHide">
      <div class="wrapper">
        <div class="wrapper-choice-box" @click="controlTap">
          <div class="wcb_top">
            <div>关联展厅产品</div>
            <div @click.stop="productComplete">完成</div>
          </div>
          <div class="wcb_search">
            <van-search
              shape="round"
              background="transparent"
              placeholder="产品关键词"
              v-model="productValue"
              maxlength="100"
              @search="productSearchConfirm"
            />
            <div class="searchBtn" @click.stop="productSearchConfirm">搜索</div>
          </div>
          <div class="wcb_already">只可以关联 1 个产品</div>
          <div class="wcb_scroll">
            <div class="wcbs_wrap wcbsp">
              <div v-for="(item, index) in productList" :key="index">
                <div
                  class="wcbsp_item "
                  :class="item.GoodsId == product.GoodsId ? 'active' : ''"
                  @click.stop="productChoice(index)"
                >
                  <img :src="item.Thumbnail" />
                  <div class="overFlowTwo">{{ item.GoodsName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <div id="output" style="width:0px;height:0px"></div>
  </div>
</template>
<script>
import TcVod from "vod-js-sdk-v6";
import { loginInfo } from "@/api/member";
import { memberGoodList } from "@/api/product";
import { postTopicList, postTopicInfo } from "@/api/topic";
import { signatureinfo, createPostVod, uploadImgByBase64 } from "@/api/publish";
import { Icon, Uploader, Toast, Overlay, Search } from "vant";
export default {
  name: "publishVideo",
  components: {
    "van-uploader": Uploader,
    "van-icon": Icon,
    "van-overlay": Overlay,
    "van-search": Search,
    Toast,
  },
  data() {
    return {
      isStore: 0, //是否是企业
      textVal: "",
      disabled: true,

      //话题
      topicShow: false,
      topicValue: "",
      topicPageIndex: 1,
      topicTotal: 0,
      topicList: [],
      topic: [{ TopicName: "", TopicId: "" }],
      topicSearched: false, //第一次进来2  有点击搜索1

      //相关产品
      productShow: false,
      productValue: "",
      productPageIndex: 1,
      productTotal: 0,
      productList: [],
      product: "",

      poster: "",
      uploadviedoSrcFull: "", //视频地址
      disabled: true, //发布按钮可点击状态
      signature: "", //签名

      latitude: "", //纬度
      longitude: "", //经度
      location: "", // 定位
    };
  },
  computed: {},
  watch: {},
  filters: {},
  methods: {
    //获取是否为企业
    getStatus() {
      var data = {};
      loginInfo(data).then((res) => {
        this.isStore = res.Data.IsStore;
      });
    },

    beforeRead(file) {
      let formData = new FormData(); // 为上传文件定义一个formData对象
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      let uploadUrl = URL.createObjectURL(file); // 将选中的上传文件转化为二进制文件，显示在页面上
      this.uploadviedoSrcFull = uploadUrl;
      this.disabled = false;

      // 前文中所述的获取上传签名的函数
      const tcVod = new TcVod({
        getSignature: this.getSignature,
      });

      // 媒体文件（视频或音频或图片），类型为 File
      const uploader = tcVod.upload({
        mediaFile: file,
      });

      // 回调结果说明
      var that = this;
      uploader
        .done()
        .then(function(doneResult) {
          localStorage.setItem("fileid", doneResult.fileId);
          localStorage.setItem("videourl", doneResult.video.url);
          Toast("视频上傳成功！");
          that.afterRead();
        })
        .catch(function(err) {
          Toast("视频上傳失敗！");
          console.log("err:", err);
        });
    },

    //上传完后的回调函数
    afterRead() {
      var video, output;
      output = document.getElementById("output");
      var canvas = document.createElement("canvas");
      var img = document.createElement("img");
      video = document.getElementById("myVideo");
      video.setAttribute("crossOrigin", "anonymous");
      canvas.width = video.clientWidth;
      canvas.height = video.clientHeight;
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      var dataURL = canvas.toDataURL("image/png");
      img.src = dataURL;
      img.width = 400;
      img.height = 300;
      output.appendChild(img);
      var data = {
        BaseData: img.src,
      };
      uploadImgByBase64(data).then((res) => {
        this.poster = res.Data;
      });
      img.style = "display:none";
    },

    //获取上传视频签名
    getSignature() {
      var data = {};
      return signatureinfo(data).then(function(res) {
        return res.Data;
      });
    },

    //删除待上传的文件
    deleteVideoClick() {
      this.uploadviedoSrcFull = "";
    },

    //获取定位
    getUserLocation() {
      var geolocation = new qq.maps.Geolocation();
      geolocation.getIpLocation(
        (position) => {
          this.longitude = position.lng;
          this.latitude = position.lat;
          this.location = position.province + position.city;
          this.disabled = false;
        },
        () => {
          this.location = "err";
        }
      );
    },

    //显示话题弹窗
    topicChange() {
      var list = this.topicList;
      list.forEach((item, index) => {
        item.selected = false;
      });
      this.topicShow = !this.topicShow;
      this.getTopicHandle();
    },
    //点击遮罩层隐藏
    onClickHide() {
      this.topicShow = false;
      this.productShow = false;
    },

    //控制弹窗区域点击
    controlTap() {
      return false;
    },

    //完成隐藏话题
    topicComplete() {
      this.topicShow = false;
    },

    // 话题输入框确认查询
    topicSearchConfirm() {
      this.topicPageIndex = 1;
      this.topicSearched = true;
      this.getTopicHandle();
    },

    //获取话题详情
    getTopicDatail() {
      var that = this;
      var data = {
        TopicId: Number(that.$route.query.hid),
      };
      postTopicInfo(data).then((res) => {
        that.topic[0].TopicName = res.Data.TopicName;
        that.topic[0].TopicId = res.Data.TopicId;
      });
    },

    //话题item选择
    topicChoice(index) {
      var list = this.topicList;
      if (this.topic.length >= 3 && !list[index].selected) {
        Toast("最多关联3个话题");
        return;
      } else if (list[index].TopicId == this.topicId && list[index].selected) {
        this.topicId = null;
      } else {
      }
      list[index].selected = !list[index].selected;
      var topic = [];
      list.forEach(function(item, index) {
        if (item.selected) {
          topic.push(item);
        }
      });
      this.topicList = list;
      this.topic = topic;
    },

    //获取话题列表
    getTopicHandle() {
      var that = this;
      var data = {
        CateId: 0,
        Type: that.topicSearched ? 1 : 2, //全部 1热门 2推荐
        Keyword: that.topicValue,
        Page: {
          PageSize: 20,
          PageIndex: that.topicPageIndex,
        },
      };
      postTopicList(data).then((res) => {
        if (that.topicPageIndex == 1) {
          that.topicList = [...res.Data.List];
        } else {
          that.topicList = [...that.topicList, ...res.Data.List];
        }
        that.topicTotal = res.Data.Total;
        if (that.topicList.length >= that.topicTotal) {
          console.log("数据加载完毕");
        } else {
          if (that.topicList.length > 0) {
            that.topicPageIndex = that.topicPageIndex += 1;
            that.getTopicHandle();
          } else {
            console.log("底部了");
          }
        }
      });
    },

    //话题删除
    topicDelete(index) {
      var idx = index;
      var topic = this.topic;
      console.log("话题删除的下标值", idx);
      topic.splice(idx, 1);
      this.topic = topic;
    },

    //展开产品弹窗
    productChange() {
      this.productShow = !this.productShow;

      this.getProductHandle();
    },

    //完成隐藏产品弹窗
    productComplete() {
      this.productShow = false;
    },

    //获取搜索框值
    productSearchConfirm() {
      this.productPageIndex = 1;
      this.getProductHandle();
    },

    //获取产品列表
    getProductHandle() {
      var that = this;
      var data = {
        Keyword: that.productValue,
        Page: {
          PageSize: 20,
          PageIndex: that.productPageIndex,
        },
      };
      memberGoodList(data).then((res) => {
        if (that.productPageIndex == 1) {
          that.productList = [...res.Data.List];
        } else {
          that.productList = [...that.productList, ...res.Data.List];
        }
        that.productTotal = res.Data.Total;
        if (that.productList.length >= that.productTotal) {
          console.log("数据加载完毕");
        } else {
          if (that.productList.length > 0) {
            that.productPageIndex = that.productPageIndex += 1;
            that.getProductHandle();
          } else {
            console.log("底部了");
          }
        }
      });
    },

    //产品item选择
    productChoice(index) {
      var index = index;
      this.product = this.product
        ? this.product.GoodsId == this.productList[index].GoodsId
          ? null
          : this.productList[index]
        : this.productList[index];
      this.disabled = false;
    },

    //发布图片动态
    submitClick() {
      var that = this;
      var topicIds = [];
      if (that.topic.length > 0) {
        that.topic.forEach(function(item, index) {
          topicIds.push(item.TopicId);
        });
      }
      if (that.uploadviedoSrcFull == "") {
        Toast("请上传视频");
        return;
      }
      var data = {
        Content: that.textVal,
        TopicId: topicIds,
        CircleId: 0,
        Address: that.location,
        GoodId:
          that.isStore == 1 ? (that.product ? that.product.GoodsId : 0) : 0,
        Lng: that.longitude ? that.longitude : 0,
        Lat: that.latitude ? that.latitude : 0,
        Thumbnail: that.poster,
        MediaUrl: localStorage.getItem("videourl"),
      };
      createPostVod(data).then((res) => {
        Toast("发布成功");
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
        localStorage.removeItem("videourl");
      });
    },
  },
  created() {
    this.getStatus();
  },
  mounted() {
    if (this.$route.query.hid) {
      this.getTopicDatail();
    } else {
      this.topic = [];
    }
  },
};
</script>
<style scoped src="../../../static/css/publish.css"></style>
